module.exports = __webpack_public_path__ + "static/make_time-a8b7f0649726673906d1efbcfcfb2dee.jpg";